var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAct(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "IconAct"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 6C3 3.9446 4.57427 2 6.84615 2H14.5368C15.3257 2 16.0828 2.3107 16.6442 2.86482L20.1074 6.28288C20.6785 6.84658 21 7.61559 21 8.41806V18C21 20.0554 19.4257 22 17.1538 22H6.84615C4.57426 22 3 20.0554 3 18V6ZM5 18C5 19.1046 5.82655 20 6.84615 20H17.1538C18.1734 20 19 19.1046 19 18V8.41806C19 8.15057 18.8928 7.89423 18.7025 7.70633L15.2393 4.28827C15.0521 4.10357 14.7998 4 14.5368 4H6.84615C5.82655 4 5 4.89543 5 6V18ZM7.5 11H13.5C13.7761 11 14 10.7761 14 10.5V9.5C14 9.22386 13.7761 9 13.5 9H7.5C7.22386 9 7 9.22386 7 9.5V10.5C7 10.7761 7.22386 11 7.5 11ZM10.5 15C10.7761 15 11 14.7761 11 14.5V13.5C11 13.2239 10.7761 13 10.5 13H7.5C7.22386 13 7 13.2239 7 13.5V14.5C7 14.7761 7.22386 15 7.5 15H10.5Z",
    fill: "#9397A6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 59 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8483 14.3493C17.9654 14.4664 17.9654 14.6564 17.8483 14.7735L14.7422 17.8796C14.6251 17.9968 14.4351 17.9968 14.318 17.8796L12.2119 15.7735C12.0947 15.6564 12.0947 15.4664 12.2119 15.3493L12.8483 14.7129C12.9654 14.5957 13.1554 14.5957 13.2726 14.7129L14.5301 15.9704L16.7876 13.7129C16.9048 13.5957 17.0947 13.5957 17.2119 13.7129L17.8483 14.3493Z",
    fill: "#9397A6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAct);
export default __webpack_public_path__ + "static/media/IconAct.4e21aea424f44ff3638f9e39a55ff1bb.svg";
export { ForwardRef as ReactComponent };